import React from 'react';
import classnames from 'classnames';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import MultipleLinesTextBubble from '@gp/components/MultipleLinesTextBubble';
// import Iconfont from '@gp/components/Iconfont';
import CardSlot from '@gp/components/CardSlot';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import PercentTendencyFloat from '@gp/components/PercentTendencyFloat';

import type { IBaseProps } from '@home/types/common';
import type { IRecord } from '@gp/types/global';

import './index.scss';

interface CommonSourceCardPropsType extends IBaseProps {
  icon?: string | JSX.Element | null;
  isTitleMultipleLinesTextBubble?: boolean;
  multipleLinesTextFields?: string[];
  multipleLinesTextFieldNames?: IRecord;
  multipleLinesTextData?: IRecord;
  title?: string;
  date?: string;
  value: string;
  percentLabel: string;
  percentV?: string | number;
  slot?: string | JSX.Element | null;
  isNoData?: boolean;
  isLoading?: boolean;
  isPercentage?: boolean;
}

const CommonSourceCard: React.FC<CommonSourceCardPropsType> = (props) => {
  const {
    style,
    className,
    isTitleMultipleLinesTextBubble = false,
    multipleLinesTextFields,
    multipleLinesTextFieldNames,
    multipleLinesTextData,
    // icon,
    title = '',
    date = '',
    value = '',
    percentLabel = '',
    percentV = 0,
    slot = null,
    isNoData = false,
    isLoading = false,
    isPercentage = true,
  } = props;

  return (
    <CardSlot
      style={style}
      className={classnames('dbg-common-source-card', className)}
      title={
        <div className="dbg-common-source-card__title">
          {isTitleMultipleLinesTextBubble ? (
            <MultipleLinesTextBubble
              fields={multipleLinesTextFields || []}
              names={multipleLinesTextFieldNames}
              data={multipleLinesTextData || {}}
            >
              <span style={{ lineHeight: '16px', fontSize: 14 }}>{title}</span>
            </MultipleLinesTextBubble>
          ) : (
            <EllipsisTextBubble
              className="title-text"
              bubbleStyle={!!date ? { width: 'auto', maxWidth: 'calc(100% - 50px)' } : {}}
              text={title}
            />
          )}
          {!!date && <span className="dbg-common-source-card__title-date">{date}</span>}
        </div>
      }
    >
      {/* <h3 className="source-card-title">{typeof icon === 'string' ? <Iconfont type={icon} /> : icon}</h3> */}
      {isLoading ? (
        <Loading loading style={{ height: 80, marginTop: 20 }} />
      ) : (
        <>
          {isNoData || (
            <>
              <div className="source-card-value">
                <div className="value-data">{value || '-'}</div>
                {isPercentage && (
                  <div className="value-percent">
                    {percentLabel && <span className="value-percent-label">{percentLabel}:&nbsp;</span>}
                    <PercentTendencyFloat className="value-percent-text" value={percentV} />
                  </div>
                )}
              </div>
              {slot && <div className="source-card-footer">{slot}</div>}
            </>
          )}
          {/* 空态 */}
          {isNoData && <NoData height={80} constomStyle={{ fontSize: 14 }} />}
        </>
      )}
    </CardSlot>
  );
};

export default React.memo(CommonSourceCard);
